<div class="aar-tertiary-card">
  <div class="aar-card-value">{{value}}</div>
  <div class="aar-card-label">{{label}}</div>
</div>
